__turbopack_context__.v({
  "faqs-questions-list": "FaqQuestions-module-scss-module__6iY5-a__faqs-questions-list",
  "question-link": "FaqQuestions-module-scss-module__6iY5-a__question-link",
});
